// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* MainTabs.css */

.header-img {
  background-color: #003399;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  min-height: 150px;
  width: 100%;
  margin-bottom: 10px;
}

/* Remove the border from the top of the tabs */
.mainTabsStyle .ant-tabs-top>.ant-tabs-nav::before {
  display: none;
}

.breadcrumbs {
  padding-top: 16px;
}

.main-lead-tabs {
  /* padding-bottom: 32px; */
}

/* tabs background */
.mainTabsStyle .ant-tabs-card.ant-tabs-small>.ant-tabs-nav .ant-tabs-tab {
  background: #003399;
  border: 2px solid #28B1FF !important;
  color: #28B1FF;
}

:where(.css-dev-only-do-not-override-1drr2mu).ant-tabs .ant-tabs-tab-btn {
  color: #28B1FF;
}

/* active tabs color */
.mainTabsStyle .header_tabs .ant-tabs-card>.ant-tabs-nav .ant-tabs-tab-active {
  color: white !important;
  background-color: #28B1FF;
}

/* active tab btn color  */
.mainTabsStyle .ant-tabs .ant-tabs-tab.ant-tabs-tab-active,
.mainTabsStyle .ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  color: #fff !important;
}

.mainTabsStyle .ant-tabs .ant-tabs-tab:hover,
.ant-tabs-tab-btn {
  color: #014fa0;
}

/* Style for tab buttons */
.mainTabsStyle .ant-tabs-nav-list .ant-tabs-tab {
  min-width: 60px;
  height: 35px;
  /* margin-right: 15px; */
  background-color: #d2dde8;
  border-radius: 20px;
  cursor: pointer;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 400;
  font-size: 14px;
}

.tab-section .header_tabs {
  display: flex;
  flex-direction: row;
  gap: 6px;
  justify-content: space-between;
  /* align-items: baseline; */
}

.header-img-height {
  height: 240px;
}

.header-title {
  font-size: 2.5rem;
  color: #00acc1;
  /* margin: 10px 0 10px 120px; */
  font-weight: bold;
  padding-left: 20px;
}

.sales-Header {
  /* font-family: robotobold; */
  font-size: 26px;
  color: #fff;
  padding-top: 15px;
  padding-bottom: 15px;
  display: flex;
  justify-content: space-between;
  /* margin: -3px 0 -25px 19vh; */
}

.appinfo {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  /* width: 765px; */
  /* height: 44px; */
  padding: 6px 12px;
  gap: 16px;
  background-color: #00184c;
  border-radius: 8px;
}

.cells {
  /* width: 132.6px; */
  height: 32px;
  gap: 2px;
}

.apptitle {
  font-size: 10px;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: 0em;
  text-align: left;

}

.appdata {
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0.5px;
  text-align: left;

}

@media (max-width: 620px) {

  /* .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn{
        color: #9197ad;
    } */
  .tab-section .header_tabs {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .TabMenu-Card {
    margin: 0 !important;
  }

  .TabMenu-Card>.ant-tabs-nav {
    background-color: #f7fbff !important;
    padding: 0 0px !important;
    box-shadow: 0px 1px 10px 0px #0000003d;
    /* margin-bottom: 2px; */
  }
}

.TabMenu-Card {
  background-color: #f7fbff;
}

/*header button */
.tab-section .ant-tabs-tab {
  height: 35px !important;
  font-weight: 500 !important;
  font-size: 14px;
  border-radius: 20px !important;
  /*background: #D2DDE8 !important;*/
}

@media (min-width: 621px) {
  .mainTabsStyle .ant-tabs-tab {
    min-width: 135px;
  }

  /* .ant-tabs-tab-btn{
        margin: 0  auto;
    } */
}

@media (max-width: 768px) {}

.tabs_button {
  border: none;
  /* margin: 0 6px; */
  border-radius: 3px;
  background-color: #ffffff;
  box-shadow: 0 2px 2px 0 rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%),
    0 1px 5px 0 rgb(0 0 0 / 20%);
  padding: 5px;
  cursor: pointer;
  /* width: 90px; */
  color: #000;
  width: 27%;
  cursor: pointer;
}

.ant-breadcrumb-link>a {
  color: #fff;
}

.ant-breadcrumb-link {
  color: #fff;
}

button.tabs_button img,
button.active_tabs_button img {
  width: 20px;
  height: 20px;
  color: #fff;
  margin-right: -4px;
  margin-bottom: 3px;
  vertical-align: middle;
}

.personSelf {
  width: 30px;
  /* height: 20px; */
  color: #fff;
  margin-right: 5px;
  margin-bottom: 3px;
}

.CardBodySelf button {
  border: none;
  /* margin: 0 6px; */
  border-radius: 3px;
  background-color: #ffffff;
  padding: 0;
  box-shadow: 0 2px 2px 0 rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%),
    0 1px 5px 0 rgb(0 0 0 / 20%);
  padding: 5px;
  cursor: pointer;
  width: 90px;
  color: #000;
}

.CardBodySelf .activateSelf {
  color: #fff;
  border: none;
  border-radius: 3px;
  padding: 0;
  padding: 5px;
  background-color: #3c3d3d;
  box-shadow: 0 2px 2px 0 rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%),
    0 1px 5px 0 rgb(0 0 0 / 20%);
  cursor: pointer;
  width: 90px;
  /* background-image: url('../i'); */
}

.tabsStyleMob .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  color: red;
  border-radius: 6px, 6px, 0px, 0px;
  Border: 1px, 1px, 0px, 1px;
  padding: 12px, 24px, 12px, 24px;
  background: linear-gradient(0deg, #D2E1FF, #D2E1FF), linear-gradient(180deg, #FFFFFF 0%, #D2E1FF 108.89%);


}

.tabsStyleMob .ant-tabs-ink-bar {
  position: absolute;
  background: #01ab4f;
  pointer-events: none;
}

.tabsStyleMob .ant-tabs-nav-list .ant-tabs-tab {
  height: 50px;
}

.tabsStyleMob .ant-tabs-nav {
  margin: 0;
}

.tabsStyleMob .ant-tabs-nav-list .ant-tabs-tab {
  height: 50px;
  padding: 0 20px;
  min-width: 50px;
  background: none;
}

/* 
.ant-card .ant-card-body {
  padding: 0;
  padding-bottom: 20px;
  padding-left: 20px;
  padding-right: 20px;
} */

.ant-card .ant-card-head {
  border-bottom: none;
  /* line-height: 0px; */
}

.ant-drawer .ant-drawer-header {
  border-bottom: none;
}

.ant-drawer .ant-drawer-body {
  padding: 10px;
  overflow: hidden;
}

@media (max-width: 375px) {
  .header-img {
    min-height: 54px;
  }

  .breadcrumbs {
    padding-left: 15px;
  }

  .appinfo {
    display: none;
  }

  .header_tabs {
    padding: 12px 16px;
  }

  .sales-Header {
    font-size: 16px;
    font-weight: 600;

    color: #fff;
    text-align: left;
    padding: 10px 16px;
  }
}

@media (max-width: 425px) {
  .header-img {
    min-height: 54px;
  }

  .breadcrumbs {
    padding-left: 15px;
  }

  .appinfo {
    display: none;
  }

  .header_tabs {
    padding: 12px 16px;
  }

  .sales-Header {
    font-size: 16px;
    font-weight: 600;
    /* font-family: 'Open Sans'; */
    color: #fff;
    text-align: left;
    padding: 10px 16px;
  }

  /* .tab-section .header_tabs {
    display: none;
  } */
}

@media (min-width: 1200px) {
  .main_container {
    max-width: 1250px !important;
  }

  .top_container {
    max-width: 1316px !important;
  }

  .main-lead-tabs {
    max-width: 1316px !important;
  }

  .backbuton {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/tabs/MainTabs.css"],"names":[],"mappings":"AAAA,iBAAiB;;AAEjB;EACE,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;EAC5B,4BAA4B;EAC5B,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA,+CAA+C;AAC/C;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA,0BAA0B;AAC1B;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,YAAY;EACZ,wBAAwB;EACxB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,+BAA+B;EAC/B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;EACb,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,SAAS;EACT,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;;AAElB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;;AAElB;;AAEA;;EAEE;;OAEK;EACL;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oCAAoC;IACpC,yBAAyB;IACzB,sCAAsC;IACtC,wBAAwB;EAC1B;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,eAAe;EACf,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;;OAEK;AACP;;AAEA,2BAA2B;;AAE3B;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB;gCAC8B;EAC9B,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,UAAU;EACV;gCAC8B;EAC9B,YAAY;EACZ,eAAe;EACf,WAAW;EACX,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB;gCAC8B;EAC9B,eAAe;EACf,WAAW;EACX,mCAAmC;AACrC;;AAEA;EACE,UAAU;EACV,iCAAiC;EACjC,0BAA0B;EAC1B,+BAA+B;EAC/B,yGAAyG;;;AAG3G;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;;;GAMG;;AAEH;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;;IAEhB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,8BAA8B;IAC9B,WAAW;IACX,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;;KAEG;AACL;;AAEA;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* MainTabs.css */\n\n.header-img {\n  background-color: #003399;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: 50% 50%;\n  min-height: 150px;\n  width: 100%;\n  margin-bottom: 10px;\n}\n\n/* Remove the border from the top of the tabs */\n.mainTabsStyle .ant-tabs-top>.ant-tabs-nav::before {\n  display: none;\n}\n\n.breadcrumbs {\n  padding-top: 16px;\n}\n\n.main-lead-tabs {\n  /* padding-bottom: 32px; */\n}\n\n/* tabs background */\n.mainTabsStyle .ant-tabs-card.ant-tabs-small>.ant-tabs-nav .ant-tabs-tab {\n  background: #003399;\n  border: 2px solid #28B1FF !important;\n  color: #28B1FF;\n}\n\n:where(.css-dev-only-do-not-override-1drr2mu).ant-tabs .ant-tabs-tab-btn {\n  color: #28B1FF;\n}\n\n/* active tabs color */\n.mainTabsStyle .header_tabs .ant-tabs-card>.ant-tabs-nav .ant-tabs-tab-active {\n  color: white !important;\n  background-color: #28B1FF;\n}\n\n/* active tab btn color  */\n.mainTabsStyle .ant-tabs .ant-tabs-tab.ant-tabs-tab-active,\n.mainTabsStyle .ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {\n  color: #fff !important;\n}\n\n.mainTabsStyle .ant-tabs .ant-tabs-tab:hover,\n.ant-tabs-tab-btn {\n  color: #014fa0;\n}\n\n/* Style for tab buttons */\n.mainTabsStyle .ant-tabs-nav-list .ant-tabs-tab {\n  min-width: 60px;\n  height: 35px;\n  /* margin-right: 15px; */\n  background-color: #d2dde8;\n  border-radius: 20px;\n  cursor: pointer;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: 400;\n  font-size: 14px;\n}\n\n.tab-section .header_tabs {\n  display: flex;\n  flex-direction: row;\n  gap: 6px;\n  justify-content: space-between;\n  /* align-items: baseline; */\n}\n\n.header-img-height {\n  height: 240px;\n}\n\n.header-title {\n  font-size: 2.5rem;\n  color: #00acc1;\n  /* margin: 10px 0 10px 120px; */\n  font-weight: bold;\n  padding-left: 20px;\n}\n\n.sales-Header {\n  /* font-family: robotobold; */\n  font-size: 26px;\n  color: #fff;\n  padding-top: 15px;\n  padding-bottom: 15px;\n  display: flex;\n  justify-content: space-between;\n  /* margin: -3px 0 -25px 19vh; */\n}\n\n.appinfo {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  /* width: 765px; */\n  /* height: 44px; */\n  padding: 6px 12px;\n  gap: 16px;\n  background-color: #00184c;\n  border-radius: 8px;\n}\n\n.cells {\n  /* width: 132.6px; */\n  height: 32px;\n  gap: 2px;\n}\n\n.apptitle {\n  font-size: 10px;\n  font-weight: 400;\n  line-height: 14px;\n  letter-spacing: 0em;\n  text-align: left;\n\n}\n\n.appdata {\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 16px;\n  letter-spacing: 0.5px;\n  text-align: left;\n\n}\n\n@media (max-width: 620px) {\n\n  /* .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn{\n        color: #9197ad;\n    } */\n  .tab-section .header_tabs {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n  }\n\n  .TabMenu-Card {\n    margin: 0 !important;\n  }\n\n  .TabMenu-Card>.ant-tabs-nav {\n    background-color: #f7fbff !important;\n    padding: 0 0px !important;\n    box-shadow: 0px 1px 10px 0px #0000003d;\n    /* margin-bottom: 2px; */\n  }\n}\n\n.TabMenu-Card {\n  background-color: #f7fbff;\n}\n\n/*header button */\n.tab-section .ant-tabs-tab {\n  height: 35px !important;\n  font-weight: 500 !important;\n  font-size: 14px;\n  border-radius: 20px !important;\n  /*background: #D2DDE8 !important;*/\n}\n\n@media (min-width: 621px) {\n  .mainTabsStyle .ant-tabs-tab {\n    min-width: 135px;\n  }\n\n  /* .ant-tabs-tab-btn{\n        margin: 0  auto;\n    } */\n}\n\n@media (max-width: 768px) {}\n\n.tabs_button {\n  border: none;\n  /* margin: 0 6px; */\n  border-radius: 3px;\n  background-color: #ffffff;\n  box-shadow: 0 2px 2px 0 rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%),\n    0 1px 5px 0 rgb(0 0 0 / 20%);\n  padding: 5px;\n  cursor: pointer;\n  /* width: 90px; */\n  color: #000;\n  width: 27%;\n  cursor: pointer;\n}\n\n.ant-breadcrumb-link>a {\n  color: #fff;\n}\n\n.ant-breadcrumb-link {\n  color: #fff;\n}\n\nbutton.tabs_button img,\nbutton.active_tabs_button img {\n  width: 20px;\n  height: 20px;\n  color: #fff;\n  margin-right: -4px;\n  margin-bottom: 3px;\n  vertical-align: middle;\n}\n\n.personSelf {\n  width: 30px;\n  /* height: 20px; */\n  color: #fff;\n  margin-right: 5px;\n  margin-bottom: 3px;\n}\n\n.CardBodySelf button {\n  border: none;\n  /* margin: 0 6px; */\n  border-radius: 3px;\n  background-color: #ffffff;\n  padding: 0;\n  box-shadow: 0 2px 2px 0 rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%),\n    0 1px 5px 0 rgb(0 0 0 / 20%);\n  padding: 5px;\n  cursor: pointer;\n  width: 90px;\n  color: #000;\n}\n\n.CardBodySelf .activateSelf {\n  color: #fff;\n  border: none;\n  border-radius: 3px;\n  padding: 0;\n  padding: 5px;\n  background-color: #3c3d3d;\n  box-shadow: 0 2px 2px 0 rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%),\n    0 1px 5px 0 rgb(0 0 0 / 20%);\n  cursor: pointer;\n  width: 90px;\n  /* background-image: url('../i'); */\n}\n\n.tabsStyleMob .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {\n  color: red;\n  border-radius: 6px, 6px, 0px, 0px;\n  Border: 1px, 1px, 0px, 1px;\n  padding: 12px, 24px, 12px, 24px;\n  background: linear-gradient(0deg, #D2E1FF, #D2E1FF), linear-gradient(180deg, #FFFFFF 0%, #D2E1FF 108.89%);\n\n\n}\n\n.tabsStyleMob .ant-tabs-ink-bar {\n  position: absolute;\n  background: #01ab4f;\n  pointer-events: none;\n}\n\n.tabsStyleMob .ant-tabs-nav-list .ant-tabs-tab {\n  height: 50px;\n}\n\n.tabsStyleMob .ant-tabs-nav {\n  margin: 0;\n}\n\n.tabsStyleMob .ant-tabs-nav-list .ant-tabs-tab {\n  height: 50px;\n  padding: 0 20px;\n  min-width: 50px;\n  background: none;\n}\n\n/* \n.ant-card .ant-card-body {\n  padding: 0;\n  padding-bottom: 20px;\n  padding-left: 20px;\n  padding-right: 20px;\n} */\n\n.ant-card .ant-card-head {\n  border-bottom: none;\n  /* line-height: 0px; */\n}\n\n.ant-drawer .ant-drawer-header {\n  border-bottom: none;\n}\n\n.ant-drawer .ant-drawer-body {\n  padding: 10px;\n  overflow: hidden;\n}\n\n@media (max-width: 375px) {\n  .header-img {\n    min-height: 54px;\n  }\n\n  .breadcrumbs {\n    padding-left: 15px;\n  }\n\n  .appinfo {\n    display: none;\n  }\n\n  .header_tabs {\n    padding: 12px 16px;\n  }\n\n  .sales-Header {\n    font-size: 16px;\n    font-weight: 600;\n\n    color: #fff;\n    text-align: left;\n    padding: 10px 16px;\n  }\n}\n\n@media (max-width: 425px) {\n  .header-img {\n    min-height: 54px;\n  }\n\n  .breadcrumbs {\n    padding-left: 15px;\n  }\n\n  .appinfo {\n    display: none;\n  }\n\n  .header_tabs {\n    padding: 12px 16px;\n  }\n\n  .sales-Header {\n    font-size: 16px;\n    font-weight: 600;\n    /* font-family: 'Open Sans'; */\n    color: #fff;\n    text-align: left;\n    padding: 10px 16px;\n  }\n\n  /* .tab-section .header_tabs {\n    display: none;\n  } */\n}\n\n@media (min-width: 1200px) {\n  .main_container {\n    max-width: 1250px !important;\n  }\n\n  .top_container {\n    max-width: 1316px !important;\n  }\n\n  .main-lead-tabs {\n    max-width: 1316px !important;\n  }\n\n  .backbuton {\n    display: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
